
import { Tables } from "@/integrations/supabase/types";
import { useQuoteResponseHandler } from "@/hooks/useQuoteResponseHandler";
import { useQuotePaymentGenerator } from "@/hooks/useQuotePaymentGenerator";
import { useQuoteDeleter } from "@/hooks/useQuoteDeleter";

type Quote = Tables<'quotes'>;

export const useQuoteOperations = (bookingId: string, quotes: Quote[], onQuoteUpdate?: () => void) => {
  const { loadingQuoteId, handleQuoteResponse } = useQuoteResponseHandler(bookingId, quotes, onQuoteUpdate);
  const { generatingPayment, generatePaymentLink } = useQuotePaymentGenerator(quotes, onQuoteUpdate);
  const { deletingQuoteId, setDeletingQuoteId, handleDeleteQuote } = useQuoteDeleter(onQuoteUpdate);

  return {
    loadingQuoteId,
    generatingPayment,
    deletingQuoteId,
    setDeletingQuoteId,
    handleQuoteResponse,
    generatePaymentLink,
    handleDeleteQuote
  };
};
